<template>
  <div class="home">
    <div class="home-header">
      <img
        class="home-header-logo"
        src="http://protocol.zhixiangjinfu.com/logo/zxy/logo.png"
        alt=""
      />
      &nbsp;&nbsp;
      <!-- img
        class="home-header-name"
        src="@/assets/home-product-name.png"
        alt=""
      / -->
      <div class="home-header-text">合规安全 信用借款</div>
    </div>

    <div class="home-card">
      <img class="home-card-icon" src="@/assets/home-title.png" alt="" />
      <div class="home-card-content product">
        <div class="product-title">
          <img
            class="product-title-logo"
            :src="orderDetailObj.logoUrl"
            alt=""
          />
          {{ orderDetailObj.productName }}
        </div>
        <div class="product-desc">最高可借额度(元)</div>

        <div class="product-amount">
          {{ money }}
        </div>
        <div class="product-info">
          <div class="product-info-item">
            <div
              class="product-info-item-value"
              v-if="orderDetailObj.app_info.key3"
            >
              {{ orderDetailObj.app_info.key3.value }}
            </div>
            <div
              class="product-info-item-title"
              v-if="orderDetailObj.app_info.key3"
            >
              {{ orderDetailObj.app_info.key3.desc }}
            </div>
          </div>
          <div class="product-info-item">
            <div
              class="product-info-item-value"
              v-if="orderDetailObj.app_info.key4"
            >
              {{ orderDetailObj.app_info.key4.value }}
            </div>
            <div
              class="product-info-item-title"
              v-if="orderDetailObj.app_info.key4"
            >
              {{ orderDetailObj.app_info.key4.desc }}
            </div>
          </div>
        </div>
        <div class="product-btn" @click="handleSubmit">立即申请</div>
        <div class="product-checkbox">
          <van-checkbox
            class="checkbox"
            v-model="checked"
            shape="square"
            checked-color="#0066FF"
          >
            <template #icon="props">
              <img
                class="product-checkbox-icon"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </template>
            我已阅读并同意<span
              v-for="item in orderDetailObj.agreementList"
              :key="item.protocolName"
              class="contract"
              @click.self.stop="handleJump(item.protocolUrl)"
              >《{{ item.protocolName }}》</span
            >
          </van-checkbox>
        </div>
      </div>
    </div>

    <div class="home-tips">
      <div class="home-tips-header">
        <img
          class="home-tips-header-icon"
          src="@/assets/icon-tips.png"
          alt=""
        />
        防骗小贴士
      </div>

      <div class="home-tips-content">
        骗子经常会以审核金、保证金、信息更正金、账户解冻金等名义实施诈骗，为了保障您的资金安全，请不要相信任何要求您支付费用的短信、邮件、电话等不实信息，谨防被骗。
      </div>
    </div>

    <van-dialog v-model="show" title="" confirmButtonColor="#345aff">
      <iframe :src="contractUrl" class="contract-wrap"></iframe>
    </van-dialog>
    <!--<div class="home-fixed">- 广州市好屋小额贷款有限责任公司 -</div>-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
  </div>
</template>

<script>
import { Checkbox } from "vant";
import {
  save_order,
  h5_get_product_info,
  apply_half_order_detail,
  apply_half_order_submit,
} from "@/api";
import utils from "@/utils/";
const { moneySplit, singleToast, qs } = utils;

export default {
  name: "HomeView",
  components: {
    // HelloWorld,
    [Checkbox.name]: Checkbox,
  },
  data: function () {
    return {
      query: { channel_code: "", orderId: "" },
      orderDetailObj: {
        app_info: {},
      },
      checked: false,
      activeIcon: require("@/assets/checkbox-checked.png"),
      inactiveIcon: require("@/assets/checkbox-default.png"),

      show: false, // 协议弹窗
      contractUrl: "", // 选中的协议
    };
  },
  computed: {
    money() {
      return moneySplit(this.orderDetailObj.app_info.key2?.value || 0);
    },
    isHalf() {
      // half?channel_code={channelcode}&order_id={order_id}&flow=half
      return (
        this.query &&
        this.query.flow === "half" &&
        this.query.order_id &&
        this.query.channel_code
      );
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.query = qs();
      const dataStr = this.query.data;
      const order_id = this.query.order_id;
      const channel_code = this.query.channel_code;
      if (this.isHalf) {
        const res = await apply_half_order_detail({ order_id, channel_code });
        this.orderDetailObj = res.data;
      } else if (dataStr) {
        this.orderDetailObj = JSON.parse(decodeURIComponent(dataStr));
      } else if (order_id) {
        const res = await h5_get_product_info({ order_id });
        this.orderDetailObj = res.data;
      } else {
        return singleToast("参数错误");
      }
      // orderDetail(this.query).then((res) => {
      //   this.orderDetailObj = res.data;
      // });
    },
    // 协议跳转
    handleJump(url) {
      // window.location.href = item.protocolUrl;
      this.contractUrl = url;
      this.show = true;
    },
    // 提交
    async handleSubmit() {
      if (!this.checked) {
        singleToast("请先阅读并同意协议");
        return;
      }
      // 提交
      // Toast.loading({
      //   duration: 0,
      //   message: "申请中...",
      //   forbidClick: true,
      // });

      try {
        let res = null;
        if (this.isHalf) {
          const order_id = this.query.order_id;
          const channel_code = this.query.channel_code;
          res = await apply_half_order_submit({ order_id, channel_code });
        } else {
          res = await save_order({
            order_id: this.orderDetailObj.app_info.order_id.value,
          });
        }
        console.log(res, "res");

        // Toast.clear();

        if (this.orderDetailObj.url) {
          window.location.href = this.orderDetailObj.url;
        } else if (res.data && res.data.url) {
          window.location.href = res.data.url;
        } else {
          this.$router.replace({
            name: "result",
          });
        }
      } catch (error) {
        console.error("提交失败:", error);
        // Toast.clear();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: DINAlternate;
  src: url("~@/assets/DIN-BoldAlternate.otf");
}

.home {
  min-height: 100vh;
  padding: 0 15px;
  background: #fff url(~@/assets/page-bg.png) 0 0/100% auto no-repeat;

  &-header {
    display: flex;
    align-items: center;
    padding: 20px 0;

    &-logo {
      width: 24px;
      height: 24px;
    }

    &-name {
      width: 54px;
      height: 19px;
      margin: 0 8px;
    }

    &-text {
      flex: 1;
      color: #fff;
    }
  }

  &-card {
    position: relative;
    //width: 100%;
    //height: 357px;
    margin-top: 8px;
    padding: 32px 12px 20px 12px;
    background: #e6ebf8;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.08);
    border-radius: 5px;

    &-icon {
      position: absolute;
      top: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 129px;
      height: 36px;
    }

    &-content {
      width: 100%;
      //height: 100%;
      background: #ffffff;
      border-radius: 5px;
    }

    .product {
      &-title {
        display: flex;
        align-items: center;
        justify-content: center;

        padding-top: 18px;
        font-weight: 500;
        font-size: 14px;
        color: #191d3f;
        line-height: 14px;

        &-logo {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
      }

      &-desc {
        padding: 23px 0 18px;
        text-align: center;
        font-size: 12px;
        color: #0a1932;
        line-height: 12px;
      }

      &-amount {
        font-family: DINAlternate, DINAlternate;
        font-weight: bold;
        font-size: 45px;
        color: #0a1932;
        line-height: 45px;
        text-align: center;
        font-style: normal;
      }

      &-info {
        position: relative;
        display: flex;
        justify-content: space-around;
        padding: 20px 0;

        &:after {
          content: "";
          position: absolute;
          top: 26px;
          left: 50%;
          transform: translateX(-50%);
          width: 1px; /*no_rem*/
          height: 23px;
          background-color: #979797;
          opacity: 0.36;
        }

        .product-info-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          &-value {
            font-family: DINAlternate, DINAlternate;
            font-weight: bold;
            font-size: 15px;
            color: #2d2f30;
          }

          &-title {
            padding-top: 10px;
            color: #9e9f9f;
            font-size: 12px;
            line-height: 12px;
          }
        }
      }

      &-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 48px;
        margin: 0 28px;
        background: #0066ff;
        border-radius: 24px;

        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 16px;
      }

      &-checkbox {
        display: flex;
        align-items: center;
        margin-top: 14px;
        padding: 0 28px 15px;

        font-size: 11px;
        color: #000000;
        line-height: 1.2;

        .contract {
          color: #0066ff;
        }
        ::v-deep .van-checkbox__icon {
          display: flex;
          align-items: center;
        }

        &-icon {
          width: 14px;
          height: 14px;
        }
      }
    }
  }

  &-tips {
    margin-top: 20px;
    //margin-left: 16px;
    &-header {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      font-weight: 500;
      font-size: 13px;
      color: #000000;
      line-height: 12px;

      &-icon {
        width: 15px;
        height: 15px;
        margin-right: 4px;
      }
    }

    &-content {
      padding: 12px;

      font-size: 12px;
      color: #797d87;
      line-height: 16px;
      text-align: justify;

      background: #f5f6f7;
      border-radius: 5px;
    }
  }

  &-fixed {
    position: fixed;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    word-break: keep-all;
    white-space: nowrap;

    font-size: 11px;
    color: #999eac;
    line-height: 11px;
  }
}
</style>
